export const FeatureFlagConst = {
  FF4390_CADASTRO_TERRITORIO_SISE: '4390-cadastro-territorio-sise'
};
